import type { ComponentProps, ReactNode } from "react";
import { BrandLogo } from "../brand-logo";

/** Cyra sign-in frame. Authentication behaviour belongs to the feature. */
export function AuthBlock({
  block: _block = "login-03",
  children,
}: {
  block?: "login-03" | "signup-03";
  children: ReactNode;
}) {
  return (
    <main className="cyra-auth">
      <section className="cyra-auth-panel" data-auth-card>
        <div className="cyra-auth-brand">
          <BrandLogo />
        </div>
        {children}
      </section>
    </main>
  );
}

export function AuthForm(props: ComponentProps<"form">) {
  return <form className="flex flex-col gap-6" {...props} />;
}

export function AuthActions({ children, split = false }: { children: ReactNode; split?: boolean }) {
  return (
    <div
      className={
        split
          ? "flex flex-wrap items-center justify-between gap-3"
          : "flex flex-col gap-3 sm:flex-row sm:items-center"
      }
    >
      {children}
    </div>
  );
}

export function AuthStack({ children }: { children: ReactNode }) {
  return <div className="flex flex-col gap-5">{children}</div>;
}

export function AuthSecretPanel({ children }: { children: ReactNode }) {
  return <div className="flex flex-col gap-4 rounded-lg border bg-muted/40 p-4">{children}</div>;
}

export function AuthChoices({ children }: { children: ReactNode }) {
  return <div className="flex flex-col gap-3">{children}</div>;
}

export function AuthIdentity({ children }: { children: ReactNode }) {
  return <p className="text-center text-sm text-muted-foreground">{children}</p>;
}

export function AuthPolicy({ children }: { children: ReactNode }) {
  return <p className="text-sm leading-6 text-muted-foreground">{children}</p>;
}
